export enum RecurringPeriod {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

type Pricing = {
  id: string;
  sku: string;
  originalPrice?: number;
  price: number;
  credits: number;
  creditType: RecurringPeriod;
  isFreeTrialEnabled: boolean;
  freeTrialInterval?: 'day' | 'week' | 'month' | 'year';
  freeTrialIntervalCount?: number;
  freeTrialCreditsAmount?: number;
};

export type Plan = {
  name: string;
  description: string;
  isPopular?: boolean;
  pricing: {
    monthly: Pricing;
    yearly: Pricing;
  };
  features: string[];
};
